import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

const PriorityManager = () => {
  const [formData, setFormData] = useState({
    startDate: "",
    endDate: "",
    type: "",
    userId: "",
  });
  const [rowData, setRowData] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    // Fetch initial data from the server
    axios
      .get("http://localhost:3001/priorities")
      .then((response) => setRowData(response.data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const columnDefs = [
    { headerName: "ID", field: "id", width: 80 },
    { headerName: "Start Date", field: "startDate", flex: 1 },
    { headerName: "End Date", field: "endDate", flex: 1 },
    { headerName: "Type", field: "type", flex: 1 },
    { headerName: "Created Date", field: "createdDate", flex: 1 },
    {
      headerName: "Action",
      cellRenderer: (params) => (
        <div className="flex space-x-2">
          <button className="bg-blue-500 text-white px-2 py-1 rounded">
            VIEW
          </button>
          <button className="bg-blue-500 text-white px-2 py-1 rounded">
            ADD MORE
          </button>
        </div>
      ),
      width: 180,
    },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.startDate) newErrors.startDate = "Start Date is required.";
    if (!formData.endDate) newErrors.endDate = "End Date is required.";
    if (!formData.type) newErrors.type = "Type is required.";
    if (!formData.userId) newErrors.userId = "User ID is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    // Simulate server submission
    const newPriority = {
      ...formData,
      createdDate: new Date().toISOString(),
      id: rowData.length + 1, // For demo, generating ID
    };

    axios
      .post("http://localhost:3001/priorities", newPriority)
      .then((response) => {
        setRowData([...rowData, newPriority]);
        setFormData({
          startDate: "",
          endDate: "",
          type: "",
          userId: "",
        });
        setIsSubmitting(false);
      })
      .catch((error) => {
        console.error("Error submitting data:", error);
        setIsSubmitting(false);
      });
  };

  const handleAddMore = () => {
    setFormData({
      startDate: "",
      endDate: "",
      type: "",
      userId: "",
    });
  };

  return (
    <div className="p-6">
      {/* Priority Form Section */}
      <div className="bg-white shadow p-6 rounded mb-6">
        <h2 className="text-lg font-bold text-red-600 mb-4">Priority</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-red-600">Start Date*</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleInputChange}
              className="w-full p-2 border rounded mt-2"
            />
            {errors.startDate && (
              <p className="text-red-500 text-sm mt-1">{errors.startDate}</p>
            )}
          </div>
          <div>
            <label className="block text-red-600">End Date*</label>
            <input
              type="date"
              name="endDate"
              value={formData.endDate}
              onChange={handleInputChange}
              className="w-full p-2 border rounded mt-2"
            />
            {errors.endDate && (
              <p className="text-red-500 text-sm mt-1">{errors.endDate}</p>
            )}
          </div>
          <div>
            <label className="block text-red-600">Type*</label>
            <select
              name="type"
              value={formData.type}
              onChange={handleInputChange}
              className="w-full p-2 border rounded mt-2"
            >
              <option value="">Select Type</option>
              <option value="Iyar">Iyar</option>
              <option value="Vaasthu">Vaasthu</option>
              <option value="Other">Other</option>
            </select>
            {errors.type && (
              <p className="text-red-500 text-sm mt-1">{errors.type}</p>
            )}
          </div>
          <div>
            <label className="block text-red-600">User IDs*</label>
            <input
              type="text"
              name="userId"
              value={formData.userId}
              onChange={handleInputChange}
              className="w-full p-2 border rounded mt-2"
              placeholder="Enter User ID"
            />
            {errors.userId && (
              <p className="text-red-500 text-sm mt-1">{errors.userId}</p>
            )}
          </div>
        </div>
        <div className="flex space-x-4 mt-4">
          <button
            onClick={handleAddMore}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            ADD MORE
          </button>
          <button
            onClick={handleSubmit}
            className="bg-green-500 text-white px-4 py-2 rounded"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "SUBMIT"}
          </button>
        </div>
      </div>

      {/* Priority Table Section */}
      <div className="bg-white shadow p-6 rounded">
        <h2 className="text-lg font-bold text-gray-700 mb-4">Priority Table</h2>
        <div className="ag-theme-alpine" style={{ height: 400, width: "100%" }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            pagination={true}
            paginationPageSize={5}
          />
        </div>
      </div>
    </div>
  );
};

export default PriorityManager;

